import { IGlobalStore } from "../../types/store";
import { IServiceState } from "./namespace";

export const PREFIX = "vk-miniapp";

export type TGlobalStateWithService = IGlobalStore & {
  [PREFIX]: IServiceState;
};
export const APP_INITIALIZATION = `${PREFIX}-initialization`;
